import React from 'react';
import {View} from 'react-native';

import Text from '/component/base/Text';
import {ProfilePage} from '/constant/TestIDs';
import {getFontFamily} from '/util/text.util';

import {styles} from './FullName.style';

export interface FullNameProps {
  name: string;
}

export const FullName: React.FC<FullNameProps> = ({name = ''}) => {
  const textStyle = {...getFontFamily('bold')};

  return (
    <View style={styles.base} accessible={true} accessibilityLabel={name}>
      <Text
        testID={ProfilePage.profileFullName}
        style={textStyle}
        variant="medium"
        allowFontScaling
        maxFontSizeMultiplier={2}>
        {name}
      </Text>
    </View>
  );
};

export default FullName;
